import type { CallerMessage } from '@acs/shared';
import { Badge, Icon } from '@acs/ui';
import { useI18n, type TranslationKey } from '../../i18n/index.js';

/**
 * What the caller asked the business to know or do (doc 28), shown on the
 * list row and in the calendar's booking dialog. NOT truncated: the note is a
 * detail about the booking, this is a thing somebody has to read and act on,
 * and a message clipped at one line is a message half-delivered.
 */
export function AppointmentMessage({ message }: { message: CallerMessage }) {
  const { t } = useI18n();
  return (
    <div className="appt-message">
      <div className="appt-message__head">
        {/* The same bubble that flags the message on the calendar block. */}
        <Icon name="message-circle" size={13} />
        {t(`message.kind.${message.kind}` as TranslationKey)}
        {message.callbackRequested && (
          <Badge tone="warning" size="sm">{t('message.callback')}</Badge>
        )}
      </div>
      {message.summary}
    </div>
  );
}
